/*
 * Created Date: 08-12-2022, 10:42:12 pm
 * Author: Hai Tran
 * Email: you@you.you
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2022 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import { useDebounceFn, useUpdateEffect } from 'ahooks'
import moment from 'moment'

import { useForm } from 'react-hook-form'

export const useTableFilter = ({ handleFetchData, querySearch = {}, queryFilters = {}, onChangeSearch = () => {} }) => {
	const methodFilter = useForm({
		defaultValues: {
			...querySearch,
			...queryFilters
		}
	})

	const { watch, getValues } = methodFilter

	const watchInputs = watch(Object.keys(querySearch))
	const watchFilters = watch(Object.keys(queryFilters))

	// console.log('============= watchInputs', watchInputs)

	const debounceFetchData = useDebounceFn(
		() => {
			const params = getValues()
			// console.log('============= params', params)
			// router.replace({
			// 	pathname: window.location.href,
			// 	query: {
			// 		...params
			// 	}
			// })

			let paramsHandler = {
				...params
			}

			if (params.created_at) {
				paramsHandler = {
					...params,
					created_at: moment(params.created_at ?? '').format()
				}
			}
			onChangeSearch(paramsHandler)
			handleFetchData({ ...paramsHandler, page: 1 })
		},
		{
			wait: 500
		}
	)

	useUpdateEffect(() => {
		debounceFetchData.run()
	}, [JSON.stringify(watchInputs)])

	useUpdateEffect(() => {
		if (queryFilters) {
			const params = getValues()
			if (queryFilters?.is_active) {
				handleFetchData({
					...params,
					is_active:
						params?.is_active === 'true' ? true : params?.is_active === 'false' ? false : params?.is_active,
					page: 1
				})
			} else {
				handleFetchData({ ...params, page: 1 })
			}
		}
	}, [JSON.stringify(watchFilters)])

	return { methodFilter }
}
